import React from "react";
import { Button, Toggletip, ToggletipActions, ToggletipContent, } from "@carbon/react";
import { HelpCenterHintType, useC3HelpCenter } from "./c3-help-center-provider";
export const HelpCenterHint = ({ children }) => {
    const { showHint, setShowHint, hintType } = useC3HelpCenter();
    return showHint ? (React.createElement(Toggletip, { defaultOpen: true, 
        // eslint-disable-next-line
        // @ts-ignore
        align: "bottom-right" },
        children,
        React.createElement(ToggletipContent, null,
            React.createElement("p", null, hintType === HelpCenterHintType.HelpCenter
                ? "Access the Help Center at any time to see your recommendations, discover guides, tutorials, or to share feedback."
                : "Access the onboarding survey from the Help Center to get personalized next steps and educational content."),
            React.createElement(ToggletipActions, null,
                React.createElement(Button, { size: "sm", onClick: () => setShowHint(false) }, "Got it"))))) : (children);
};
